import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "estates scroll-wrapper" }
const _hoisted_4 = { class: "estates-header" }
const _hoisted_5 = {
  key: 0,
  class: "items-count"
}
const _hoisted_6 = {
  key: 1,
  class: "items-count"
}
const _hoisted_7 = { class: "wrapper-table" }
const _hoisted_8 = { class: "table-scroll" }
const _hoisted_9 = { class: "table-default" }
const _hoisted_10 = { class: "checkbox" }
const _hoisted_11 = { class: "controls" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: "share-lots-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-title" }, "Select project(s)", -1)),
          _createVNode($setup["InputSearch"], {
            class: "search",
            modelValue: $setup.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
            placeholder: "Search",
            theme: "filter gray"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            ($setup.getSelectedProjects > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.plural($setup.getSelectedProjects, "project")) + " selected", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.plural($props.projects.length, "project")), 1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.projects, (item, idx) => {
                      return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode($setup["CheckboxInput"], {
                            label: item.title,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                            modelValue: item.isSelected,
                            "onUpdate:modelValue": ($event: any) => (item.isSelected = $event)
                          }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.text), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "button default",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.close()))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary send",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.emits('selectEstates'), $setup.close())),
            disabled: !$props.projects.length
          }, "Confirm", 8, _hoisted_12)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}